<!-- 用户协议组件 -->
<template>
  <div class="box-wrapper" id="notice">
    <h3 v-if="title" class="title">{{ title }}</h3>
    <ul>
      <li v-for="(item, index) in contentList" :key="index">
        <h4 v-if="item.title">{{ item.title }}</h4>
        <div
          class="text"
          v-for="(ite, inde) in item.text"
          :key="inde"
          v-html="ite"
        ></div>
        <br />
      </li>
    </ul>
    <p class="footer-text" v-if="footer">{{ footer }}</p>
  </div>
</template>

<script>
  export default {
    props: {
      title: String, // 文本标题，
      content: {
        // 展示文本内容
        type: Array,
        default: () => []
      },
      footer: String, // 右下角右对齐文本
      btnText: {
        // 返回按钮文本
        type: String,
        default: '回到上一级'
      }
    },
    data() {
      return {}
    },
    computed: {
      contentList() {
        return this.content.map(item => {
          if (typeof item.text === 'string') {
            return {
              ...item,
              text: [item.text]
            }
          } else {
            return item
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    font-family: PingFangSC-Medium;
    font-size: 36px;
    font-weight: bold;
    color: #283452;
    text-align: center;
    padding: 60px;
    line-height: 60px;
  }
  ul {
    margin: 0 50px 0;
  }
  h4 {
    margin-bottom: 20px;
    font-family: PingFangSC-Medium;
    font-size: 32px;
    color: #21252D;
  }
  .text {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #4C5463;
    span {
      font-size: 20px;
    }
  }
  .footer-text {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #4C5463;
    text-align: right;
    margin: 0 60px 0;
  }
  .btn {
    background: #6387ff;
    color: #fff;
    border-radius: 100px;
    height: 96px;
    line-height: 96px;
    width: 670px;
    text-align: center;
    position: fixed;
    left: 40px;
    bottom: 40px;
    font-family: PingFangSC-Regular;
    font-size: 32px;
    color: #ffffff;
    text-align: center;
  }
  /deep/ strong {
    font-family: PingFangSC-Medium;
    font-size: 26px;
    color: #0F1300;
    text-decoration: underline;
  }
</style>
